import script from "./Checker.vue?vue&type=script&setup=true&lang=ts"
export * from "./Checker.vue?vue&type=script&setup=true&lang=ts"

import "../assets/css/online-proxy-checker.css?vue&type=style&index=0&id=4d054ecf&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d054ecf"]])

export default __exports__